import React from 'react';
import { Route, Switch } from 'react-router-dom';

///USUÁRIO///
import ListarUsuarios from './components/Usuario/Listar-Usuarios';
import CadastrarUsuario from './components/Usuario/Cadastrar-Usuario';

///PRESTADOR///
import ListarPrestador from './components/Prestador/Listar-Prestador';
import ListarTipoPrestador from './components/Prestador/Listar-Tipo-Prestador';
import CadastrarPrestador from './components/Prestador/Cadastrar-Prestador';
import CadastrarTipoPrestador from './components/Prestador/Cadastrar-Tipo-Prestador';

///EMPRESA///
import ListarEmpresa from './components/Empresa/Listar-Empresa';
import CadastrarEmpresa from './components/Empresa/Cadastrar-Empresa';

///IMGENS///
import UploadImagens from './components/Imagem/Upload-Imagens';

///CONFIG///
import ListarConfigs from './components/Configs/Listar-Configs';
import CadastrarConfigs from './components/Configs/Cadastrar-Configs';
import ListarRoles from './components/Configs/Listar-Perfis-Acesso'
import CadastrarRole from './components/Configs/Cadastrar-Perfil-Acesso';

///NOTIFICAÇÕES///
import ListarNotificacoes from './components/Notificacoes/Listar-Notificacoes';
import CriarNotificacao from './components/Notificacoes/Criar-Notificacao';
import DetalheNotificacao from './components/Notificacoes/Detalhe-Notificacao';

import Dashboard from './components/Dashboard';

import PerfilUsuario from './components/Usuario/Perfil-Usuario';


const AppRouter = () => {
    return (
        <Switch>
            <Route path="/" exact component={Dashboard} />
            <Route path="/usuarios/listar" component={ListarUsuarios} />
            <Route path="/usuarios/cadastrar" component={CadastrarUsuario} />
            <Route path="/usuarios/visualizar/:id" component={CadastrarUsuario} />

            <Route path="/prestador/listar" component={ListarPrestador} />
            <Route path="/prestador/cadastrar" component={CadastrarPrestador} />
            <Route path="/prestador/editar/:id" component={CadastrarPrestador} />

            <Route path="/prestador/tipo/listar" component={ListarTipoPrestador} />
            <Route path="/prestador/tipo/cadastrar" component={CadastrarTipoPrestador} />
            <Route path="/prestador/tipo/editar/:id" component={CadastrarTipoPrestador} />

            <Route path="/empresa/listar" component={ListarEmpresa} />
            <Route path="/empresa/cadastrar" component={CadastrarEmpresa} />
            <Route path="/empresa/editar/:id" component={CadastrarEmpresa} />

            <Route path="/imagem/cadastrar" component={UploadImagens} />

            <Route path="/configs/listar" component={ListarConfigs} />
            <Route path="/configs/cadastrar" component={CadastrarConfigs} />
            <Route path="/configs/editar/:id" component={CadastrarConfigs} />

            <Route path="/notificacoes/criar" component={CriarNotificacao} />
            <Route path="/notificacoes/listar" component={ListarNotificacoes} />
            <Route path="/notificacoes/detalhe/:id" component={DetalheNotificacao} />

            <Route path="/roles/listar" component={ListarRoles} />
            <Route path="/roles/cadastrar" component={CadastrarRole} />
            <Route path="/roles/editar/:id" component={CadastrarRole} />
            {/* <Route path="/cadastro/lojas/cadastrar" component={CadastrarLoja} /> */}

            <Route path="/profile" component={PerfilUsuario} />
        </Switch>
    );
};

export default AppRouter;